import React from 'react';
const SLOTTABLE_NAME = 'vulcanui-slottable';
const Slottable = ({ children }) => {
    return React.createElement(React.Fragment, null, children);
};
Slottable.displayName = 'Slottable';
Slottable.toString = () => `.${SLOTTABLE_NAME}`;
export default Slottable;
//# sourceMappingURL=slottable.js.map